// Avatar (DESIGN §5.7). Outros: círculo com iniciais/foto. Próprio aluno: quadrado tinta com corte-tile.
// As iniciais (ou o ícone do oculto) aparecem NA HORA, sem esqueleto; a foto entra por cima com fade e, se falhar,
// some e ficam as iniciais (docs/prototipo/comunidade-fotos-marcacao.html §2 e §10).
import { cn } from "../lib/cn";
import { FotoSobre } from "./Foto";
import { Icones } from "./icones";

export type TamanhoAvatar = 24 | 32 | 40 | 48 | 56 | 72;

const TAMANHO: Record<TamanhoAvatar, string> = {
  // 24: quem entregou a conquista, na citação do motivo (docs/prototipo/conquistas-cadastro.html §15)
  24: "size-6 text-[9px]",
  32: "size-8 text-rotulo",
  40: "size-10 text-apoio",
  48: "size-12 text-titulo",
  56: "size-14 text-h2",
  72: "size-[72px] text-h1",
};

/** Iniciais a partir do nome exibido ("Ana Paula Souza" -> "AS"; "Rafa M" -> "RM"). */
export function iniciais(nome: string): string {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "";
  const primeira = partes[0]![0] ?? "";
  const ultima = partes.length > 1 ? (partes[partes.length - 1]![0] ?? "") : "";
  return (primeira + ultima).toUpperCase();
}

export interface PropsAvatar {
  /** Nome já resolvido pela privacidade (o servidor nunca manda nome que o aluno não escolheu). */
  nome: string;
  fotoUrl?: string | null;
  tamanho?: TamanhoAvatar;
  /** Avatar do próprio aluno (Início, Perfil): quadrado com corte. */
  proprio?: boolean;
  /** Anel de nível; "ouro" só para o 1º lugar da temporada. */
  anel?: "tinta" | "ouro";
  /** Oculto no ranking e sem foto: ícone genérico. */
  oculto?: boolean;
  className?: string;
}

export function Avatar({ nome, fotoUrl, tamanho = 40, proprio, anel, oculto, className }: PropsAvatar) {
  const mostrarFoto = !!fotoUrl && !oculto;
  return (
    <span
      role="img"
      aria-label={oculto ? "Aluno oculto" : nome}
      className={cn(
        "relative inline-grid shrink-0 place-items-center overflow-hidden font-semibold",
        TAMANHO[tamanho],
        proprio ? "rounded-card corte-tile bg-tinta text-sobre-tinta" : "rounded-full bg-recuo text-texto-2",
        anel && "ring-2 ring-offset-2 ring-offset-painel",
        anel === "tinta" && "ring-tinta",
        anel === "ouro" && "ring-ouro",
        className,
      )}
    >
      {oculto ? <Icones.perfil size={20} aria-hidden /> : <span aria-hidden>{iniciais(nome)}</span>}
      {mostrarFoto && <FotoSobre key={fotoUrl} src={fotoUrl} />}
    </span>
  );
}
